import Card from "./Card";

function Tours({tours, removeTour}){
    return(
        <div className="container">
            <div className="title">
                <h2>Plan With Nikku</h2>
            </div>

            {/* If key is uses then always send a key with map function */}

            <div className="cards">
                {
                    tours.map((tour) => {
                        return <Card key={tour.id} {...tour} removeTour={removeTour}></Card>
                    })
                }
            </div>
        </div>
    );

}

export default Tours;